<template>
    <community-posts-content
        :posts=posts
        :isLoading=isLoading
        :currentPage=currentPage
        :lastPage=lastPage
        @loadMorePosts="loadMorePosts"
    />
</template>

<script>
    import CommunityPostsContent from '../../organisms/community/CommunityPostsContent'

    export default {
        name: "ProfilePosts",
        components: { CommunityPostsContent },
        props: {
            userId: Number
        },
        data() {
            return {
                posts: [],
                currentPage: 1,
                lastPage: 10,
                isLoading: true
            }
        },

        methods: {
            getPosts(page, posterId){
                this.$axios.get('/api/rest/community/post', {params : {page: page, posterId: posterId }})
                    .then((response) => {
                        this.posts = this.posts.concat(response.data.data)
                        this.currentPage = response.data.current_page
                        this.lastPage = response.data.last_page
                        this.isLoading = false

                    })
                    .catch((e)=>{
                        console.log(e);
                    })
            },

            loadMorePosts(){
                this.getPosts(this.currentPage + 1, this.userId)
            }

        },

        mounted() {
            this.getPosts(1, this.userId)
        },


    }
</script>
